import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { IFRAME_CONVERTER_TOKEN, IFrameConverter } from './i-frame.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        iFrameFeature: {
          module: () => import('./i-frame.module').then((m) => m.IFrameModule),
          cmsComponents: ['iframe'],
        },
      }
    }),
    {
      provide: IFRAME_CONVERTER_TOKEN,
      useExisting: IFrameConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        iframe: IFRAME_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class IFrameFeatureModule {}
